import Vue from 'vue'
import Vuex from 'vuex'
import http from '../api/request'

Vue.use(Vuex)

// Minimal store. Most state is in component-local data + localStorage tokens;
// add Vuex modules here only when state needs to be shared across views.
export default new Vuex.Store({
  state: {
    // /api/abp/application-configuration 的 currentUser（{ id, userName, name, ... }）
    user: null,
    // 授权策略表 { 'Api.AdminMenus.Products': true, ... }；null = 尚未加载。
    // 驱动左侧菜单显隐与路由守卫（后端接口另有自己的权限校验，这里只管前端可见性）。
    grantedPolicies: null,
  },
  getters: {
    // 无 permission 要求的菜单永远可见；策略已加载但未命中 → 不可见。
    can: (state) => (policy) =>
      !policy || !!(state.grantedPolicies && state.grantedPolicies[policy]),
  },
  mutations: {
    setUser(state, user) { state.user = user },
    setGrantedPolicies(state, policies) { state.grantedPolicies = policies },
  },
  actions: {
    async loadAppConfig({ commit }) {
      const cfg = await http.get('/api/abp/application-configuration', {
        params: { includeLocalizationResources: false },
      })
      commit('setUser', (cfg.currentUser && cfg.currentUser.isAuthenticated) ? cfg.currentUser : null)
      commit('setGrantedPolicies', (cfg.auth && cfg.auth.grantedPolicies) || {})
      return cfg
    },
    resetAuth({ commit }) {
      commit('setUser', null)
      commit('setGrantedPolicies', null)
    },
  },
})
